export const STATE_FILTER_SELECT_OPTION = 'STATE_FILTER_SELECT_OPTION'
export const SEARCH_FILTER_SELECT_OPTION = 'SEARCH_FILTER_SELECT_OPTION'
export const RESET_FILTERS = 'RESET_FILTERS'

export const PROJECT_COMMENCE_FETCH = 'PROJECT_COMMENCE_FETCH'
export const PROJECT_DID_LOAD = 'PROJECT_DID_LOAD'
export const PROJECT_DID_ERROR = 'PROJECT_DID_ERROR'
export const PROJECT_RESET_ERROR = 'PROJECT_RESET_ERROR'
export const ATTRIBUTES_DID_LOAD = 'ATTRIBUTES_DID_LOAD'
export const SURVEY_QA_SAVED = 'SURVEY_QA_SAVED'
export const ATTRIBUTES_DETAILS_DID_LOAD = 'ATTRIBUTES_DETAILS_DID_LOAD'
export const QUESTIONNAIRE_DID_LOAD = 'QUESTIONNAIRE_DID_LOAD'
export const HISTORY_DID_LOAD = 'HISTORY_DID_LOAD'

export const LINEITEMS_COMMENCE_FETCH = 'LINEITEMS_COMMENCE_FETCH'
export const LINEITEMS_DID_LOAD = 'LINEITEMS_DID_LOAD'
export const LINEITEMS_BY_PROJECTID_DID_LOAD = 'LINEITEMS_BY_PROJECTID_DID_LOAD'
export const LINEITEMS_BY_PROJECTID = 'LINEITEMS_BY_PROJECTID'
export const LINEITEMS_DID_ERROR = 'LINEITEMS_DID_ERROR'
export const LINEITEMS_RESET_ERROR = 'LINEITEMS_RESET_ERROR'
export const LIMIT_OFFSET_SORT_SET = 'LIMIT_OFFSET_SORT_SET'
export const USERS_DID_LOAD = 'USERS_DID_LOAD'
export const USER_ASSIGNMENT_UPDATE_SUCCUSS = 'USER_ASSIGNMENT_UPDATE_SUCCUSS'

export const SEARCHBAR_NEW_QUERY = 'SEARCHBAR_NEW_QUERY'

export const AUTH_STATE_SUCCESS = 'AUTH_STATE_SUCCESS'
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT'
export const STATUS_RECEIVED = 'STATUS_RECEIVED'
export const USERINFO_DID_LOAD = 'USERINFO_DID_LOAD'

export const SERVER_ERROR = 'SERVER_ERROR'
export const HIDE_CUSTOM_ERROR = 'HIDE_CUSTOM_ERROR'
export const SHOW_CUSTOM_ERROR = 'SHOW_CUSTOM_ERROR'
